import { defineMessages } from 'react-intl';


const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  categoryTramits: {
    id: 'Category',
    defaultMessage: 'Category',
  },
  linkTitle: {
    id: 'Link Title',
    defaultMessage: 'Link Title',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
});

export const schema = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description', 'imageChoice', 'linkTitle', 'linkUrl'],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
        widget: 'text',
      },
      description: {
        title: props.intl.formatMessage(messages.description),
        widget: 'text',
      },
      imageChoice: {
        title: props.intl.formatMessage(messages.categoryTramits),
        type: 'choice',
        choices: [
          ['tramits', 'Tràmits'],
          ['transparencia', 'Transparència'],
        ],
      },
      linkTitle: {
        title: props.intl.formatMessage(messages.linkTitle),
        widget: 'text',
      },
      linkUrl: {
        title: 'URL',
        widget: 'url',
        allow_external: true,
      },
    },
  };
};

export default schema;